import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import LoginPage from "./pages/auth/Login.tsx";
import MainLayout from "./layouts/MainLayout.tsx";
import Documents from "./pages/Documents/Documents.tsx";
import Disclaimer from "./static/Disclaimer.tsx";
import PrivacyPolicy from "./static/PrivacyPolicy.tsx";
import TermsOfUse from "./static/TermsOfUse.tsx";
import SignUp from "./pages/auth/Register.tsx";
import { RunDetails } from "./pages/Runs/RunDetails.tsx";
import Runs from "./pages/Runs/Runs.tsx";
import ForgotPassword from "./pages/auth/ForgotPassword.tsx";
import ProfilePage from "./pages/auth/ProfilePage.tsx";
import DocumentDetails from "./pages/Documents/DocumentDetails.tsx";
import DocumentDetailsOld from "./pages/Documents/DocumentDetailsOld.tsx";
import Dashboard from "./pages/Dashboard/Dashboard.tsx";
import ShowAnalytics from "./pages/Analytics/ShowAnalytics.tsx";
import RecordedAnalytics from "./pages/Analytics/RecordedAnalytics.tsx";
// import Releases from "./pages/Releases/Releases.tsx";
import { ReleaseDetails } from "./pages/Releases/ReleaseDetails.tsx";
import InvitedRegistration from "./pages/auth/InvitedRegistration.tsx";
import CollaboratorAnalytics from "./pages/Analytics/CollaboratorAnalytics.tsx";
import AllMembers from "./pages/AllMembers/AllMembers.tsx";
import EarlyAccessUserAgreement from "./static/EarlyAccessUserAgreement.tsx";
import AnalyticsDashboard from "./pages/Analytics/AnalyticsDashboard.tsx";
import { ShowDetails } from "./pages/Shows/ShowDetails.tsx";
import UnderConstruction from "./pages/404/UnderConstruction.tsx";
import BrandDealAnalytics from "./pages/Analytics/BrandDealAnalytics.tsx";
import ManagerAnalyticsDashboard from "./pages/Analytics/ManagerAnalyticsDashboard.tsx";
import MgrShowAnalytics from "./pages/Analytics/Manager/MgrShowAnalytics.tsx";
import MgrCommissionAnalytics from "./pages/Analytics/Manager/MgrCommissionAnalytics.tsx";
import RunExpenseAnalytics from "./pages/Analytics/RunExpenseAnalytics.tsx";
import AgentViewAnalytics from "./pages/Analytics/AgentViewAnalytics.tsx";
import ResetPassword from "./pages/auth/ResetPassword.tsx";
import MgrAgentViewAnalytics from "./pages/Analytics/Manager/MgrAgentViewAnalytics.tsx";
import MgrBrandDealAnalytics from "./pages/Analytics/Manager/MgrBrandDealAnalytics.tsx";

const isAuthenticated = () => {
  const token = localStorage.getItem("authToken");
  return !!token;
};

const PublicRoute = ({ children }: { children: JSX.Element }) => {
  return !isAuthenticated() ? children : <Navigate to="/" />;
};

const PrivateRoute = ({ children }: { children: JSX.Element }) => {
  return isAuthenticated() ? children : <Navigate to="/login" />;
};

export default function App() {
  return (
    <Router>
      <Routes>
        {/* Public Routes */}
        <Route
          path="/login"
          element={
            <PublicRoute>
              <LoginPage />
            </PublicRoute>
          }
        />
        <Route
          path="/register"
          element={
            <PublicRoute>
              <SignUp />
            </PublicRoute>
          }
        />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/disclaimer" element={<Disclaimer />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/terms-of-use" element={<TermsOfUse />} />
        <Route
          path="/early-access-user-agreement"
          element={<EarlyAccessUserAgreement />}
        />
        <Route
          path="/register/invited/:accessKey"
          element={<InvitedRegistration />}
        />
        <Route path="/reset-password/" element={<ResetPassword />} />

        {/* Protected Routes */}
        <Route
          path="/"
          element={
            <PrivateRoute>
              <MainLayout />
            </PrivateRoute>
          }
        >
          <Route path="/" element={<Dashboard />} />
          <Route path="/analytics" element={<AnalyticsDashboard />} />
          <Route
            path="/analytics/manager"
            element={<ManagerAnalyticsDashboard />}
          />
          <Route path="/analytics/shows" element={<ShowAnalytics />} />
          <Route
            path="/analytics/runs/expenses"
            element={<RunExpenseAnalytics />}
          />
          <Route
            path="/analytics/brand-deals"
            element={<BrandDealAnalytics />}
          />
          <Route
            path="/analytics/agent-view"
            element={<AgentViewAnalytics />}
          />
          <Route
            path="/analytics/manager/shows"
            element={<MgrShowAnalytics />}
          />
          <Route
            path="/analytics/manager/commissions"
            element={<MgrCommissionAnalytics />}
          />
          <Route
            path="/analytics/manager/brand-deals"
            element={<MgrBrandDealAnalytics />}
          />
          <Route
            path="/analytics/manager/agent-view"
            element={<MgrAgentViewAnalytics />}
          />

          <Route path="/analytics/recorded" element={<RecordedAnalytics />} />
          <Route
            path="/analytics/collabs"
            element={<CollaboratorAnalytics />}
          />
          <Route path="/documents" element={<Documents />} />
          <Route path="/documents/:id" element={<DocumentDetails />} />
          <Route path="/runs" element={<Runs />} />
          {/* <Route path="/releases" element={<Releases />} /> */}
          <Route path="/releases" element={<UnderConstruction />} />

          <Route path="/releases/:id" element={<ReleaseDetails />} />
          <Route path="/runs/:id" element={<RunDetails />} />
          <Route path="/runs/:runId/shows/:showId" element={<ShowDetails />} />
          <Route path="/profile/user/" element={<ProfilePage />} />
          <Route path="/profile/team/members" element={<AllMembers />} />
        </Route>

        {/* Catch-all route */}
        <Route
          path="*"
          element={<Navigate to={isAuthenticated() ? "/" : "/login"} />}
        />
      </Routes>
    </Router>
  );
}
